import { RecomendacionValoracion } from './evaluacion.model';

export interface IOpcionPreguntaCuestionarioSnp {
  id?: number;
  texto?: string;
  valor?: number;
  descripcion?: string;
}

export class OpcionPreguntaCuestionarioSnp implements IOpcionPreguntaCuestionarioSnp {
  constructor(public id?: number, public texto?: string, public valor?: number, public descripcion?: string) {}

  static fromObject(item: IOpcionPreguntaCuestionarioSnp): OpcionPreguntaCuestionarioSnp {
    const opcion = new OpcionPreguntaCuestionarioSnp();
    for (const [key, value] of Object.entries(item)) {
      opcion[key] = value;
    }
    return opcion;
  }
}

export interface IPreguntaCuestionarioSnp {
  id?: number;
  criterio?: string;
  descripcionCriterio?: string;
  pregunta?: string;
  ponderacion?: number;
  opciones?: Array<OpcionPreguntaCuestionarioSnp>;
  campoTexto?: string;
}

export class PreguntaCuestionarioSnp implements IPreguntaCuestionarioSnp {
  constructor(
    public id?: number,
    public criterio?: string,
    public dimension?: string,
    public descripcionCriterio?: string,
    public pregunta?: string,
    public ponderacion?: number,
    public opciones?: Array<OpcionPreguntaCuestionarioSnp>,
    public campoTexto?: string
  ) {
    if (!opciones) this.opciones = [];
  }

  static fromObject(item: IPreguntaCuestionarioSnp): PreguntaCuestionarioSnp {
    const pregunta = new PreguntaCuestionarioSnp();

    const transformations = {
      opciones: (opciones: Array<OpcionPreguntaCuestionarioSnp>) =>
        opciones !== undefined ? (opciones ?? []).map(OpcionPreguntaCuestionarioSnp.fromObject) : [],
    };

    for (const [key, value] of Object.entries(item)) {
      pregunta[key] = key == 'opciones' ? transformations.opciones(value) : value;
    }
    return pregunta;
  }
}

export interface IRespuestaCuestionarioSnp {
  dimension?: string;
  criterio?: string;
  preguntaId?: number;
  preguntaNombre?: string;
  preguntaPonderacion?: number;
  respuestaId?: number;
  respuestaNombre?: string;
  respuestaPonderacion?: number;
  respuestaDescripcion?: string;
  campoTexto?: string;
  respuestaCampoTexto?: string;
}

export class RespuestaCuestionarioSnp implements IRespuestaCuestionarioSnp {
  constructor(
    public dimension?: string,
    public criterio?: string,
    public preguntaId?: number,
    public preguntaNombre?: string,
    public preguntaPonderacion?: number,
    public respuestaId?: number,
    public respuestaNombre?: string,
    public respuestaPonderacion?: number,
    public respuestaDescripcion?: string,
    public campoTexto?: string,
    public respuestaCampoTexto?: string
  ) {}

  static fromObject(item: IRespuestaCuestionarioSnp): RespuestaCuestionarioSnp {
    const respuesta = new RespuestaCuestionarioSnp();
    for (const [key, value] of Object.entries(item)) {
      respuesta[key] = value;
    }
    return respuesta;
  }
}

export interface ICuestionarioSnp {
  contestaciones?: Array<RespuestaCuestionarioSnp>;
  comentariosGenerales?: string;
  estaCompleto?: boolean;
  faltantes?: Array<number>;
  recomendacion?: RecomendacionValoracion;
  urlDictamen?: string;
  revisionID?: string;
}

export class CuestionarioSnp implements ICuestionarioSnp {
  constructor(
    public contestaciones?: Array<RespuestaCuestionarioSnp>,
    public comentariosGenerales?: string,
    public estaCompleto?: boolean,
    public faltantes?: Array<number>,
    public recomendacion?: RecomendacionValoracion,
    public urlDictamen?: string,
    public revisionID?: string
  ) {
    if (!contestaciones) {
      this.contestaciones = [];
    }
    if (!faltantes) {
      this.faltantes = [];
    }
  }

  static fromObject(item: ICuestionarioSnp): CuestionarioSnp {
    const cuestionario = new CuestionarioSnp();
    for (const [key, value] of Object.entries(item)) {
      cuestionario[key] = value;
    }
    return cuestionario;
  }
}

export interface IRespuestaComparacion {
  cvu?: string;
  contestacion?: RespuestaCuestionarioSnp;
  comentariosGenerales?: string;
  estadoRevision?: string;
  recomendacion?: boolean;
}

export class RespuestaComparacion implements IRespuestaComparacion {
  constructor(
    public cvu?: string,
    public contestacion?: RespuestaCuestionarioSnp,
    public comentariosGenerales?: string,
    public estadoRevision?: string,
    public recomendacion?: boolean
  ) {}
}
